export default {
      id: "icon-arrow-bottom-usage",
      viewBox: "0 0 14.506 7.774",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-arrow-bottom",
      toString: function () {
        return this.url;
      }
    }